import { useCallback } from 'react';

import { usePintoAnnouncementNotificationsLazyQuery } from '../core/graphql/operation-hooks';
import { PintoAnnouncementNotificationsFilter, PintoAnnouncementNotificationsSortBy, SortType } from '../core/graphql/types';

const INITIAL_LIMIT = 10;

const useQueryPintoAnnouncementNotifications = () => {
  const [queryPintoAnnouncementNotifications, { data, variables, loading }] = usePintoAnnouncementNotificationsLazyQuery({ fetchPolicy: 'network-only' });

  const fetchPintoAnnouncementNotifications = useCallback(
    (filter?: PintoAnnouncementNotificationsFilter) => {
      queryPintoAnnouncementNotifications({
        variables: {
          filter: {
            limit: INITIAL_LIMIT,
            sortBy: PintoAnnouncementNotificationsSortBy.Created,
            sortType: SortType.Desc,
            ...filter,
          },
        },
      });
    },
    [queryPintoAnnouncementNotifications],
  );

  const onFetchMorePintoAnnouncementNotifications = useCallback(() => {
    if (loading || !data?.pintoAnnouncementNotifications?.pageInfo.hasNextPage) return;
    fetchPintoAnnouncementNotifications?.({
      ...variables?.filter,
    });
  }, [loading, data?.pintoAnnouncementNotifications?.pageInfo.hasNextPage, fetchPintoAnnouncementNotifications, variables?.filter]);

  return {
    fetchPintoAnnouncementNotifications,
    onFetchMorePintoAnnouncementNotifications,
    pintoAnnouncementNotifications: data?.pintoAnnouncementNotifications,
    isLoadingPintoAnnouncementNotifications: loading,
  };
};

export default useQueryPintoAnnouncementNotifications;
